import { TableMode } from '@/models/TableMode';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import { goodRoadsSliceActions } from '@/modules/goodRoad/slice';
import { SupportedGameLiveData } from '@/modules/hostLive/models';
import { hostLiveSliceActions } from '@/modules/hostLive/slice';
import { getMainUserState } from '@/modules/main/selector';
import store from '@/store/store';
import { getIsRestState } from '@/utils/commonFunc';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { batch } from 'react-redux';
import { SupportedGame } from '../../../modules/host/models';
import { hostsSliceActions } from '../../../modules/host/slice';
import {
    convertIsGoodRoad,
    convertResultToRecord,
} from '../../../utils/games/baccarat';
import { BaccaratResult } from '../../games/baccarat';
import { GameState } from '../../games/enums/GameState';
import { GameType } from '../../games/enums/GameType';
import { Poker } from '../../host/Poker';
import { CMDScInitBaccarat, ICommand } from '../live';
import { CMDBaccarat } from '../live/CMDBaccarat';
import { CMDLiveBaccaratData } from '../live/CMDLiveBaccaratData';
import { AbstractHandler } from './AbstractHandler';

export class CMDScInitBaccaratHandler extends AbstractHandler {
    _command: CMDScInitBaccarat;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScInitBaccarat;
    }
    override convertResult(result: CMDLiveBaccaratData): BaccaratResult {
        const newResult = Object.assign(
            this.convertBaseResult(result.BaseData.BaseResult),
            {
                PlayerCards: result.BaseData.playerCards,
                BankerCards: result.BaseData.bankerCards,
                PokerData: result.PokerData.map(
                    p =>
                        ({
                            SlotIndex: p.SlotIndex,
                            CardIndex: p.CardIndex,
                        }) as Poker
                ),
            }
        ) as BaccaratResult;
        return newResult;
    }
    convertPokerResult(result: CMDBaccarat): BaccaratResult {
        const newResult = Object.assign(
            this.convertBaseResult(result.BaseResult),
            {
                PlayerCards: result.playerCards,
                BankerCards: result.bankerCards,
            }
        ) as BaccaratResult;
        return newResult;
    }
    override handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const { IsInternalTest } = getMainUserState(state);
        const game = {} as SupportedGame;
        const liveData = {} as SupportedGameLiveData;
        const info = this.convertInformation(this._command.Information);
        const hostId = info.HostId;
        const restMode = getIsRestState(
            this._command.Information.Rest,
            IsInternalTest
        );
        liveData.GameType = GameType.Baccarat;
        liveData.CurrentState = this._command.CurrentState;
        liveData.CurrentResult = this.convertResult(
            this._command.CurrentResult
        );
        game.OldResult = this._command.OldResult.filter(o => {
            if (o.BaseResult.Result === 0) return false;
            return true;
        }).map(o => this.convertPokerResult(o));
        game.OldResult = game.OldResult.filter(
            (arr, index, self) =>
                index === self.findIndex(t => t.GameID === arr.GameID)
        );

        liveData.ResultReleased = false;
        game.IsRest = restMode.isRest;
        game.IsPause = restMode.isPause;
        game.IsInternalTest =
            IsInternalTest &&
            this._command.Information.Rest == TableMode.InternalTest;

        const convertedRecord =
            liveData.CurrentState === GameState.Shuffle
                ? []
                : game.OldResult.map(r =>
                      convertResultToRecord(r as BaccaratResult, true)
                  );
        const isGoodRoad = convertIsGoodRoad(this._command.GoodRoad);
        batch(() => {
            dispatch(
                tableBetSliceActions.initTable({
                    hostId: hostId,
                    gameId: this._command.CurrentResult.BaseData.BaseResult
                        .GameID,
                })
            );
            dispatch(hostLiveSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostLiveSliceActions.updateInformation(info));
            dispatch(hostsSliceActions.gameInit({ hostId, game, liveData }));
            dispatch(hostsSliceActions.updateInformation(info));
            dispatch(
                hostsSliceActions.updateRecord({
                    hostId,
                    record: convertedRecord,
                    gameType: GameType.Baccarat,
                })
            );
            dispatch(
                goodRoadsSliceActions.update({
                    HostId: hostId,
                    isGoodRoad,
                    isRest: game.IsRest,
                })
            );
        });
    }
}
